import { defineStore } from 'pinia'
import axios from 'axios'

function findSiteIndex(sites, site) {
  for (let i = 0; i < sites.length; i += 1) {
    // if (sites[i].domain_name === site.domain_name && sites[i].name === site.name) {
    if (sites[i].id === site.id) {
      return i
    }
  }

  return -1
}

export const useOrganization = defineStore('organization', {
  state: () => ({
    isLoading: false,
    id: null,
    name: null,
    sites: [],
  }),
  getters: {
    getSiteById: (state) => (id) => state.sites.find((site) => site.id == id),
  },
  actions: {
    async setId(id) {
      this.id = id
    },
    async get(id) {
      if (!id) {
        return false
      }

      this.isLoading = true

      const org = await axios.get(`/core/v1/organizations/${id}`)

      if (org) {
        this.setData(org)
      }

      this.isLoading = false

      return {
        id: this.id,
        name: this.name,
        sites: this.sites,
      }
    },
    async create(data) {
      this.isLoading = true

      const org = await axios.post('/core/v1/organizations', {
        name: data.name,
      })

      this.setData(org)
      this.isLoading = false

      return {
        id: this.id,
        name: this.name,
        sites: this.sites,
      }
    },
    async getSites() {
      if (!this.id) {
        return false
      }

      this.isLoading = true

      const sites = await axios.get(`/core/v1/organizations/${this.id}/sites`)

      this.sites = sites?.results || []
      this.isLoading = false

      return this.sites
    },
    async getSitesSimplified() {
      if (!this.id) {
        return false
      }

      this.isLoading = true

      const sites = await axios.get(`/core/v1.1/organizations/${this.id}/sites`)

      this.sites = sites?.results || []
      this.isLoading = false

      return this.sites
    },
    async createSite({ domain, name }) {
      this.isLoading = true

      const site = await axios.post(`/core/v1/organizations/${this.id}/sites`, {
        domain_name: domain,
        name: name,
      })

      this.sites.push(site)
      this.isLoading = false

      return site
    },
    async updateCustomDomain({ id, domain }) {
      this.isLoading = true
      // const siteData = this.getSiteById(id)
      // const siteData = state.sites.find((site) => site.id == id);
      const updateData = {
        custom_domain: domain,
      }
      // Only update domain if changed
      // if (domain !== siteData.domain.split('.')[0]) {
      //   updateData.domain_name = domain
      // }

      const site = await axios.patch(`/core/v1.1/organizations/${this.id}/sites/${id}`, updateData)

      const index = findSiteIndex(this.sites, site)
      if (index === -1) {
        this.sites.push(site)
      } else {
        this.sites[index] = site
      }

      this.isLoading = false

      return site
    },

    async updateSiteLanguages({ id, defaultLanguage, activeLanguages }) {
      const site = await axios.patch(`/core/v1.1/organizations/${this.id}/sites/${id}`, {
        default_language: defaultLanguage,
        active_languages: activeLanguages,
      })

      const index = findSiteIndex(this.sites, site)
      if (index === -1) {
        this.sites.push(site)
      } else {
        this.sites[index] = site
      }

      return site
    },

    async updateName({ name }) {
      this.isLoading = true
      const org = await axios.patch(`/core/v1/organizations/${this.id}`, { name })
      this.setData(org)
      this.isLoading = false
      return org
    },

    async updateSiteDomain({ id, domain }) {
      this.isLoading = true
      const site = await axios.patch(`/core/v1.1/organizations/${this.id}/sites/${id}`, {
        domain_name: domain,
      })

      const index = findSiteIndex(this.sites, site)
      if (index === -1) {
        this.sites.push(site)
      } else {
        this.sites[index] = site
      }

      this.isLoading = false
      return site
    },

    async accountReset() {
      return await axios.post(`/core/v1/organizations/${this.id}/account-reset`)
    },

    setData(data) {
      this.id = data.id
      this.name = data.name
      this.suscription = data.suscription
      this.suscriptionValidUntil = data.subscription_valid_until
      this.isSuscriptionValid = data.is_subscription_valid
    },
  },
})
